import { render, staticRenderFns } from "./voidapply.vue?vue&type=template&id=78beca38&scoped=true&"
import script from "./voidapply.vue?vue&type=script&lang=js&"
export * from "./voidapply.vue?vue&type=script&lang=js&"
import style0 from "./voidapply.vue?vue&type=style&index=0&id=78beca38&lang=less&scoped=true&"
import style1 from "./voidapply.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78beca38",
  null
  
)

export default component.exports